import { useMemo } from 'react';
import { differenceInSeconds } from 'date-fns';
import { PeriodRequired } from '../utils/timer/enums';
import { IFormat } from '../utils/timer/interfaces/IFormat';

interface IState {
    secondsLeft: number;
    timestamp: number;
    format: Record<number, IFormat>;
}

const MINUTE = 60;
const HOUR = MINUTE * MINUTE;
const DAY = HOUR * 24;
const MONTH = DAY * 30;
const YEAR = DAY * 365;

const format = {
    [YEAR]: PeriodRequired.Y,
    [MONTH]: PeriodRequired.O,
    [DAY]: PeriodRequired.D,
    [HOUR]: PeriodRequired.H,
    [MINUTE]: PeriodRequired.M,
    0: PeriodRequired.S,
};

const useLeftTime = (endTime: number): IState =>
    useMemo(() => {
        const now = Date.now();
        const secondsLeft = differenceInSeconds(endTime, now);

        return {
            secondsLeft,
            timestamp: now,
            format,
        };
    }, [endTime]);

export default useLeftTime;
